import { PayloadAction } from "@reduxjs/toolkit";
import { UpsellState } from "../../models/UpsellsState";
import { GetUpsellPayload } from "../../payload/GetUpsell/GetUpsellPayload";

const getAdditionalFetch = (state: UpsellState, action: PayloadAction<GetUpsellPayload>) => {
    state.isLoading = true;
}

export default getAdditionalFetch;